import SourceService from './sourceService.model';
import ProfileAttribute from './profileAttribute.model';
import { Utils } from '@/core/Utils';
import ComponentImportConfig from './componentImportConfig.model';
import ConfigProfileSectionCondition from './configProfileSectionCondition.model';

export default class Section {
    public id: number = 0;
    public title: string = "";
    public name: string = "";
    public componentName: string = "";
   // public isList: boolean = false;
   // public isTab: boolean = false;
    public visible: boolean = true;
    public isParent: boolean = false;
    public isRequired: boolean = false;
    public sourceServices: Array<SourceService> = [];
    public profileAttributes: Array<ProfileAttribute> = [];
    public guid: string = Utils.newGUID();
    public visualuacionTypeId?: number | null = null;
    public visualuacionType : any = undefined;
    public isOpen : boolean = true;

    public psOnline : boolean = true;
    public psOnlineMovil : boolean = true;
    public psWeb : boolean = true;
    public psWebMovil : boolean = true;
    public isAuthenticationRequired : boolean = true;
    
    public configProfileSectionConditions: Array<ConfigProfileSectionCondition> = [];
    public sections: Array<Section> = [];
    public configProfileId: number| null = null;
    public parentSectionId?:number | null = null;
    public configRequiredSectionId?:number | null = null;
    public componentImportConfigId?:number | null = null;
    public componentImportConfig?:ComponentImportConfig = new ComponentImportConfig();
    public orden : number = 1;
    public deleted: boolean = false;
    init(){
        this.visible = true;
        this.id = 0;
        this.configProfileId = 0;
        this.parentSectionId = null;
        this.configRequiredSectionId = null;
        this.componentImportConfigId = null;
        this.componentImportConfig = new ComponentImportConfig();
        this.title = "";
        this.name = "";
        this.componentName = "";
     //   this.isList = false;
     //   this.isTab = false;
        this.psOnline = true;
        this.psOnlineMovil = true;
        this.psWeb = true;
        this.psWebMovil = true;
        this.isAuthenticationRequired = true;
        this.orden = 0;
        this.isParent = false;
        this.isRequired = false;
        this.sourceServices = [];
        this.profileAttributes = [];
        this.guid = Utils.newGUID();
        this.visualuacionTypeId = null;
        this.visualuacionType = undefined;
        this.isOpen = true;
        this.configProfileSectionConditions= [];
        this.sections  = [];
        this.deleted = false;
    }
}